import React from "react";
import Navbar from "../Navbar/Navbar";
import SecondStep from "../Second_step/Second_step";
import "./Main_page.css";
function Main_page() {
  
  return (
    <div className=" bg-dark pb-5">
      <SecondStep />
    </div>
  );
}

export default Main_page;
